// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__2MF5j","flex":"Footer_flex__UU6Be"};